import { useToast } from '@/hooks/use-toast';
import { useDeleteCampaign } from '../hooks/use-campaigns';
import { useApolloClient } from '@apollo/client';
import { GET_CAMPAIGNS } from '../../../queries/campaigns';
import { ActionDialog } from './action-dialog';

interface DeleteCampaignDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  campaignId: string;
  campaignName: string;
  merchantId: string;
}

export function DeleteCampaignDialog({
  open,
  onOpenChange,
  campaignId,
  campaignName,
  merchantId
}: DeleteCampaignDialogProps) {
  const { toast } = useToast();
  const { remove, loading } = useDeleteCampaign(merchantId);
  const client = useApolloClient();

  const handleDelete = async () => {
    try {
      await remove(campaignId);
      // Force refetch campaigns
      await client.refetchQueries({
        include: [GET_CAMPAIGNS]
      });
      toast({
        title: 'Success',
        description: 'Campaign deleted successfully.'
      });
      onOpenChange(false);
    } catch (_error) {
      toast({
        title: 'Error',
        description: 'Failed to delete campaign. Please try again.',
        variant: 'destructive'
      });
    }
  };

  return (
    <ActionDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete Campaign"
      description={`Are you sure you want to delete the campaign "${campaignName}"? This action cannot be undone.`}
      actionLabel="Delete"
      loadingLabel="Deleting..."
      actionVariant="destructive"
      onAction={handleDelete}
      loading={loading}
    />
  );
}
